import axios from 'axios';

const baseURL = process.env.ENV === 'dev' ? process.env.API_URL_LOCAL : process.env.API_URL_PROD || 'http://localhost:4080/api';
// Créez une instance d'Axios avec votre base URL
const api = axios.create({
  baseURL: baseURL
});
// Ajoutez un interceptor pour chaque requête sortante
api.interceptors.request.use(
  (config) => {
    // Récupérez le token JWT depuis le stockage local (localStorage)
    const token = localStorage.getItem('token');

    // Si un token est disponible, ajoutez-le dans l'en-tête "Authorization"
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Ne pas remplacer le Content-Type s'il s'agit d'un formulaire multipart
    // ou si l'en-tête X-Override-Content-Type est présent
    if (!config.headers['Content-Type'] || 
        (config.headers['X-Override-Content-Type'] !== 'true' && 
         !config.headers['Content-Type'].includes('multipart/form-data'))) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    // Supprimer l'en-tête X-Override-Content-Type après utilisation
    if (config.headers['X-Override-Content-Type']) {
      delete config.headers['X-Override-Content-Type'];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
